<template>
  <div class="login-box">
    <div class="top d-flex a-center j-sb">
      <div class="code d-flex a-center">
        <img src="@/assets/img/login/account.png" alt="" class="crr" v-if="showCode" @click="change">
        <img src="@/assets/img/login/scan.png" alt="" class="crr" v-else @click="change">
        <p class="col-main f-size-14" v-if="showCode">账号密码登录</p>
        <p class="col-main f-size-14" v-else>扫码登录更便捷</p>
      </div>
      <img src="@/assets/img/login/close.png" alt="" class="close crr" @click="closeLoginTip">
    </div>
    <div class="code-box" v-loading="codeLoading" v-if="showCode">
      <div class="qrcode">
        <template v-if="[-1, 0, 2].includes(codeType)">
          <img :src="qrcodeUrl" alt="">
          <div class="wrap d-flex a-center j-center" v-if="[-1, 2].includes(codeType)">
            <i class="el-icon-refresh-right crr" @click="getQrCode"></i>
          </div>
        </template>
        <div class="code-yes d-flex a-center j-center" v-if="[1, 3].includes(codeType)">
          <div style="text-align: center;">
            <img src="@/assets/img/yikan.png" alt="">
            <p>扫描成功</p>
          </div>
        </div>
      </div>
      <div class="tips">{{codeMessage}}</div>
    </div>
    <template v-else>
      <div class="tabs d-flex">
        <p :class="{active: loginType == 2}" @click="loginType = 2">账号密码登录</p>
        <!-- <p :class="{active: loginType == 1}" @click="loginType = 1">手机号登录</p> -->
      </div>
      <div class="content">
        <div class="item d-flex a-center">
          <img src="@/assets/img/login/user.png" alt="" class="icon">
          <el-input type="tel" v-model="mobile" clearable placeholder="请输入手机号"></el-input>
        </div>
        <!-- 手机号登录 -->
        <div class="item d-flex a-center" v-if="loginType == 1">
          <img src="@/assets/img/login/pwd.png" alt="" class="icon">
          <el-input type="text" clearable placeholder="验证码"></el-input>
          <button class="code-btn" :style="{ background: get_code_back_color }">{{get_code_text}}</button>
        </div>
        <!-- 密码登录 -->
        <template v-else>
          <div class="item d-flex a-center">
            <img src="@/assets/img/login/suo.png" alt="" class="icon">
            <el-input show-password  v-model="pwd" clearable placeholder="密码"></el-input>
          </div>
          <div class="item d-flex a-center">
            <img src="@/assets/img/login/pwd.png" alt="" class="icon">
            <el-input type="text" v-model="verifyCode" clearable placeholder="验证码"></el-input>
            <img class="iiimg" v-loading="loading" @click="getImgCode" :src="imgCode" />
          </div>
        </template>
      </div>
      <div class="agree d-flex a-center">
        <el-checkbox v-model="checked"></el-checkbox>
        <p class="color-9 f-size-14">同意<span class="crr" @click="toUrl(1)">《服务条款》</span>和<span class="crr" @click="toUrl(2)">《隐私政策》</span></p>
      </div>
      <div class="btn-box">
        <button class="mix-btn" @click="submit">登录</button>
      </div>
    </template>
  </div>
</template>
<script>
import md5 from 'js-md5';
export default {
  data () {
    return {
      loginType: 2,
      checked: false,
      get_code_text: "发送验证码",
      get_code_back_color: "#03B355",
      imgCode: '',
      loading: false,
      code_id: '',
      mobile: '',
      pwd: '',
      verifyCode: '',
      loginLoading: false,
      showCode: false,
      qrcodeUrl: '',
      timer: null,
      codeMessage: '',
      codeType: 0,
      codeLoading: true
    }
  },
  created() {
    this.getImgCode()
  },
  methods: {
    change() {
      this.showCode = !this.showCode
      if (this.showCode) {
        this.getQrCode()
      } else {
        clearInterval(this.timer)
      }
    },
    getQrCode() {
      this.codeLoading = true
      this.$api.login.getWechatQrcode({
        page: 'pages-A/grant/index',
        version: 'trial',
        is_hyaline: true
      }).then(res => {
        this.qrcodeUrl = this.$utils.baseURL + res.data.data.path
        this.refreshCode(res.data.data.ticket)
        this.timer = setInterval(() => {
          this.refreshCode(res.data.data.ticket)
        }, 3000)
      })
    },
    refreshCode(ticket) {
      this.$api.login.refreshTicket({
        ticket: ticket
      }).then(res => {
        this.codeLoading = false
        this.codeMessage = res.data.data.message
        this.codeType = res.data.data.status
        if (this.codeType == -1 || this.codeType == 2) {
          clearInterval(this.timer)
        } else if (this.codeType == 3) {
          clearInterval(this.timer)
          this.$message.success('登录成功！')
          this.$store.commit('setLoginTip', false)
          this.$store.commit('setLoginContent', res.data.data.accessToken)
          this.$store.commit('setLoginState', true)
          this.getUserInfo()
          this.getRole()
        }
      })
    },
    toUrl(index) {
      if (index == 1) {
        window.open('https://open.xaou.sn.cn/viewdetail/236367549160226816', '_blank')
      } else if (index == 2) {
        window.open('https://open.xaou.sn.cn/viewdetail/236367585815298048', '_blank')
      }
    },
    closeLoginTip() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.$store.commit('setLoginTip',false)
    },
    getImgCode() {
      this.loading = true
      this.$api.login.captcha().then((res) => {
        this.loading = false
        if (res.code === 'SUCCESS') {
          this.code_id = res.data.id
          this.imgCode = this.$utils.baseURL + res.data.captcha_image
        }
      })
    },
    submit() {
      if (!this.mobile) {
        this.$message.warning("请输入手机号")
        return
      }
      if (this.loginType === 1) {
        if (!this.code) {
          this.$message.warning("请输入手机验证码")
        } else if (!this.checked) {
          this.$message.warning("请阅读并同意服务条款")
        } else {
          this.loginLoading = true
          this.$api.login.smscode_login({
            captcha: this.code,
            captcha_session_id: this.smsid,
            phone_number: this.mobile
          }).then((res) => {
            this.loginLoading = false
            if (res.code === "SUCCESS") {
              this.setData(res.data)
            } else {
              this.$message.warning(res.message)
              this.getImgCode()
            }
          })
        }
      } else {
        if (!this.pwd) {
          this.$message.warning("请输入密码")
        } else if (!this.verifyCode) {
          this.$message.warning("请输入验证码")
        } else if (!this.checked) {
          this.$message.warning("请阅读并同意服务条款")
        } else {
          this.loginLoading = true
          this.$api.login.userLogin({
            appid: this.appid,
            captcha_session_id: this.code_id,
            captcha: this.verifyCode,
            username: this.mobile,
            password: md5(md5(this.pwd))
          }).then((res) => {
            this.loginLoading = false
            if (res.code === "SUCCESS") {
              this.setData(res.data)
            } else {
              this.$message.warning(res.message)
              this.getImgCode()
            }
          })
        }
      }
    },
    setData(data) {
      this.$message.success('登录成功！')
      this.$store.commit('setLoginTip', false)
      this.$store.commit('setLoginContent', data.authorization.id)
      this.$store.commit('setLoginPhone', this.mobile)
      this.$store.commit('setLoginState', true)
      this.getUserInfo()
      this.getRole()
    },
    // 角色
    getRole() {
      this.$api.user.userRoles().then(res => {
        this.$utils.setItem('roles', res.data.data)
        if (res.data.data.length == 1) {
          this.$store.commit('setUserRole',res.data.data[0].role_id)
          if (this.$route.path == '/course/online-details') {
            this.$router.replace(`/course/online-detailsToken?course_id=${this.$route.query.course_id}&learnType=COURSE&train_id=${this.$route.query.train_id || ''}`)
          } else if (this.$route.path == '/course/practice-details') {
            this.$router.replace(`/course/practice-detailsToken?course_id=${this.$route.query.course_id}&learnType=COURSE&train_id=${this.$route.query.train_id || ''}`)
          } else if(this.$route.path == '/course/plan-details') {
            this.$router.replace(`/course/plan-detailsToken?train_id=${this.$route.query.train_id}`)
          } else {
            if (this.$route.path !== '/home') {
              this.$router.replace('/home')
            }
          }
        } else {
          this.$store.commit('setChangeRole',true)
        }
      })
    },
    // 个人资料
    getUserInfo() {
      this.$api.user.userDetail().then((res) => {
        this.$store.commit('setUserInfo', res.data.data)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.login-box{
  background: #FFFFFF;
  border-radius: 8px;
  width: 430px;
  .code-box{
    height: 450px;
    .qrcode{
      width: 400px;
      height: 400px;
      margin: auto;
      position: relative;
      img{
        width: 400px;
        height: 400px;
      }
      .wrap{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 1;
        background: rgba($color: #FFFFFF, $alpha: 0.98);
        i{
          color: #6E6E6E;
          font-size: 40px;
        }
      }
      .code-yes{
        width: 100%;
        height: 100%;
        img{
          width: 60px;
          height: 60px;
        }
        p{
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          margin-top: 24px;
          letter-spacing: 2px;
        }
      }
    }
    .tips{
      margin-top: 10px;
      text-align: center;
    }
  }
  .top{
    padding: 10px 0;
    .code{
      img{
        width: 30px;
        height: 30px;
      }
      p{
        background: url('@/assets/img/login/kuang.png') no-repeat;
        background-size: 100% 100%;
        padding: 4px 8px 4px 20px;
      }
    }
    .close{
      width: 20px;
      height: 20px;
    }
  }
  .tabs{
    p{
      font-size: 26px;
      font-weight: bold;
      position: relative;
      flex: 1;
      text-align: center;
      cursor: pointer;
    }
    .active{
      color: #03B355;
    }
    .active::after{
      content: '';
      width: 60px;
      height: 3px;
      background-color: #03B355;
      position: absolute;
      left: 50%;
      bottom: -12px;
      margin-left: -30px;
    }
  }
  .content{
    padding: 40px 0 20px;
    height: 230px;
    .item{
      height: 52px;
      border-radius: 2px;
      border: 1px solid #D9D9D9;
      padding-left: 13px;
      margin-bottom: 23px;
      overflow: hidden;
      .icon{
        width: 16px;
        height: 16px;
      }
      .code-btn{
        height: 52px;
        width: 168px;
        font-size: 18px;
        color: #fff;
      }
      .iiimg{
        width: 148px;
        height: 52px;
      }
    }
  }
  .agree{
    p{
      margin-left: 4px;
      span{
        color: #333;
      }
    }
  }
  .btn-box{
    padding: 20px 0;
  }
}
/deep/.el-input__inner{
  border: none;
}
</style>
